import React from "react"
import Components from "./components.js"

const Page = ({ blok }) => (
  <>
    {blok.body &&
      blok.body.map(blokItem =>
        React.createElement(Components(blokItem.component), {
          key: blokItem._uid,
          blok: {
            ...blokItem,
            currentLanguage: blok.currentLanguage,
            seoLinks: blok.seoLinks,
          },
        })
      )}
  </>
)

export default Page
